import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { showAlert } from "@utils/Alert";
import { CategoryApi, CategoryDataType } from "@/api/CategoryApi";

const CategoryIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await CategoryApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'La Categoria no puedo ser eliminado');
    } else {
      showAlert('success', 'La Categoria fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  return (
    <PageContainer
      title="Categorias"
      backUrl="/user/products"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/category')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<CategoryDataType>
        ref={modelRef}
        fetchData={(...args) => CategoryApi.fetchAll(...args)}
        filterProps={[
          {
            key: "codigo",
            filterType: "contains"
          },
          {
            key: "nombre",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "codigo",
          },
          {
            key: "nombre"
          }
        ]}
        listActions={[
          {
            href: "/user/category/{:id}",
            actionTitle: "Editar Categoria",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Categoria",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Categoria",
              confirmMessage: "¿Seguro que desea eliminar esta Categoria?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default CategoryIndex;
